
define('text!modules/legacy/modules/my-performance/states/my-performance_history/template.html',[],function () { return '<div class="lls-row hide-for-print u-marginTopDefault"><div class=lls-col-xs-12><div class=c-card><history period-id=MyPerformanceHistoryCtrl.periodId is-routed=true></history></div></div></div>';});

